<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data () {
    return {};
  },
  components: {
  }
};
</script>
<style lang="scss">
@import "style/main";
</style>
